import { useSelector } from 'react-redux'
import { v4 as uuid } from 'uuid'
import { FormattedCaller } from 'components/fields/Submit'
import { selectTicket, selectCurrentUser, selectVehicleFuelType, selectFormsState } from 'redux/appStore'
import { User } from 'types/redux'
import {
  generateCommentsPayload,
  generateCustomerPayload,
  generateServicePayload,
  generateVehiclePayload,
  generateRidePayload,
} from './utils'
import { EventTypes } from 'types/events'
import { useLocalTimeZone } from 'hooks/utils'
import { useExchangeLocation, useVehicleLocation } from 'hooks/redux/useLocations'
import { HERORideEvent } from '../../types/universalPayload'
import { Branch } from 'types/branch'
import useBranchHours from 'hooks/solr/useBranchHours'

export const useUniversalPayload = () => {
  const ticket = useSelector(selectTicket)
  const vehicleLocation = useVehicleLocation()
  const { timezone } = useLocalTimeZone({ lat: vehicleLocation?.latitude, lon: vehicleLocation?.longitude })
  const agent = useSelector(selectCurrentUser) as User
  const form = useSelector(selectFormsState)
  const caller = form.caller as unknown as FormattedCaller
  const vehicleFuelType = useSelector(selectVehicleFuelType)
  const vehicleSpareTire =
    ticket.vehicle?.equipmentInfo?.length !== 0
      ? ticket.vehicle?.equipmentInfo?.filter(
          (vehicle) => vehicle.shortDescription && vehicle.shortDescription.includes('Spare tire'),
        )
      : []
  const hasSpareTire = vehicleSpareTire && vehicleSpareTire.length > 0
  let date: any = new Date()
  let startDateForBranchHours = date.toISOString().split('T')
  startDateForBranchHours = startDateForBranchHours[0]
  let endDateForBranchHours: any = new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().split('T')
  endDateForBranchHours = endDateForBranchHours[0]

  const exchangeLocation = useExchangeLocation() as Branch

  const { data: branchHourData } = useBranchHours(
    exchangeLocation ? exchangeLocation.id : null,
    startDateForBranchHours,
    endDateForBranchHours,
  )

  return async (formService: any, eventType?: EventTypes) => {
    const externalId = uuid()
    const customer = generateCustomerPayload(caller)
    const vehicle = generateVehiclePayload(ticket.vehicle, vehicleFuelType)
    const service = generateServicePayload(formService, eventType, ticket, timezone, agent)
    const comments = generateCommentsPayload(formService, hasSpareTire, eventType, branchHourData)
    let ride: HERORideEvent | undefined
    if (formService?.rideAlongLocation) {
      ride = generateRidePayload(formService, timezone)
    }

    return { externalId, customer, vehicle, service, comments, ...(ride ? { ride } : {}) }
  }
}

export const useUniversalCancelPayload = () => {
  return async (serviceData: any) => {
    const externalId = serviceData?.serviceRequest?.externalId || 'N/A'
    const dispatchId = serviceData?.callId
    const service = {
      requestedService: serviceData?.services[0].name || 'Fuel',
      serviceStatus: {
        code: 'CA',
        description: 'Cancelled',
        dateCreated: new Date().toISOString(),
        modifiedDate: null,
      },
    }
    return { externalId, dispatchId, service }
  }
}
